// extracted by mini-css-extract-plugin
export default {"tagBoxCon":"TagBox_tagBoxCon__+73CI","tagTitle":"TagBox_tagTitle__XfIPc","tagContent":"TagBox_tagContent__4qXD3"};